const state = {
  status: "",
  profile: localStorage.getItem("profile")
    ? JSON.parse(localStorage.getItem("profile"))
    : {},
  profileAccess: localStorage.getItem("profile-access")
    ? JSON.parse(localStorage.getItem("profile-access"))
    : ""
};

const getters = {
  getProfileAccess: state => state.profileAccess,
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
};

const actions = {
  userRequest: ({ commit }, data) => {
    commit("userRequest");
    commit("userSuccess", {
      id: data.user.ID,
      name: data.user.FIO,
      phone: data.user.PHONE,
      email: data.user.EMAIL,
      address: data.user.ADDRESS
    });
    commit("userAccess", data.featurelist);
  }
};

const mutations = {
  userRequest: state => {
    state.status = "loading";
  },
  userSuccess: (state, data) => {
    state.status = "success";
    localStorage.setItem("profile", JSON.stringify(data));
    state.profile = data;
  },
  userAccess: (state, data) => {
    localStorage.setItem("profile-access", JSON.stringify(data));
    state.profileAccess = data;
  },
  authLogout: state => {
    state.profile = {};
    localStorage.setItem("profile", "");
    localStorage.setItem("profile-access", "");
    state.profileAccess = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
